<div class="fill" [style.width.%]="percent"></div>
<div class="text">{{ displayText }}</div>
